var map = {
	"./AddressTemplate.vue": [
		"./src/views/Papers/pages/Paper/components/Templates/AddressTemplate.vue",
		0,
		27
	],
	"./AmountOfChangeTemplate.vue": [
		"./src/views/Papers/pages/Paper/components/Templates/AmountOfChangeTemplate.vue",
		0,
		28
	],
	"./AmountReceivedTemplate.vue": [
		"./src/views/Papers/pages/Paper/components/Templates/AmountReceivedTemplate.vue",
		0,
		29
	],
	"./BankTemplate.vue": [
		"./src/views/Papers/pages/Paper/components/Templates/BankTemplate.vue",
		0,
		30
	],
	"./BarcodeTemplate.vue": [
		"./src/views/Papers/pages/Paper/components/Templates/BarcodeTemplate.vue",
		0,
		31
	],
	"./CircleTemplate.vue": [
		"./src/views/Papers/pages/Paper/components/Templates/CircleTemplate.vue",
		0,
		32
	],
	"./ContactTemplate.vue": [
		"./src/views/Papers/pages/Paper/components/Templates/ContactTemplate.vue",
		0,
		33
	],
	"./DateTemplate.vue": [
		"./src/views/Papers/pages/Paper/components/Templates/DateTemplate.vue",
		0,
		34
	],
	"./DiscountAtEndTemplate.vue": [
		"./src/views/Papers/pages/Paper/components/Templates/DiscountAtEndTemplate.vue",
		0,
		35
	],
	"./DiscountTemplate.vue": [
		"./src/views/Papers/pages/Paper/components/Templates/DiscountTemplate.vue",
		0,
		36
	],
	"./FormulaTemplate.vue": [
		"./src/views/Papers/pages/Paper/components/Templates/FormulaTemplate.vue",
		0,
		37
	],
	"./ImageTemplate.vue": [
		"./src/views/Papers/pages/Paper/components/Templates/ImageTemplate.vue",
		0,
		38
	],
	"./LineTemplate.vue": [
		"./src/views/Papers/pages/Paper/components/Templates/LineTemplate.vue",
		0,
		39
	],
	"./MarketplaceDiscountTemplate.vue": [
		"./src/views/Papers/pages/Paper/components/Templates/MarketplaceDiscountTemplate.vue",
		0,
		40
	],
	"./MarketplaceIdTemplate.vue": [
		"./src/views/Papers/pages/Paper/components/Templates/MarketplaceIdTemplate.vue",
		0,
		41
	],
	"./NumberItemInOrderTemplate.vue": [
		"./src/views/Papers/pages/Paper/components/Templates/NumberItemInOrderTemplate.vue",
		0,
		42
	],
	"./NumberProductInOrderTemplate.vue": [
		"./src/views/Papers/pages/Paper/components/Templates/NumberProductInOrderTemplate.vue",
		0,
		43
	],
	"./NumberTemplate.vue": [
		"./src/views/Papers/pages/Paper/components/Templates/NumberTemplate.vue",
		0,
		44
	],
	"./OrderCreatorTemplate.vue": [
		"./src/views/Papers/pages/Paper/components/Templates/OrderCreatorTemplate.vue",
		0,
		45
	],
	"./ParcelNumberTemplate.vue": [
		"./src/views/Papers/pages/Paper/components/Templates/ParcelNumberTemplate.vue",
		0,
		46
	],
	"./ProductTableTemplate.vue": [
		"./src/views/Papers/pages/Paper/components/Templates/ProductTableTemplate.vue",
		0,
		47
	],
	"./PromocodeTemplate.vue": [
		"./src/views/Papers/pages/Paper/components/Templates/PromocodeTemplate.vue",
		0,
		48
	],
	"./PublisherTemplate.vue": [
		"./src/views/Papers/pages/Paper/components/Templates/PublisherTemplate.vue",
		0,
		49
	],
	"./RecipientTemplate.vue": [
		"./src/views/Papers/pages/Paper/components/Templates/RecipientTemplate.vue",
		0,
		50
	],
	"./RemarkTemplate.vue": [
		"./src/views/Papers/pages/Paper/components/Templates/RemarkTemplate.vue",
		0,
		51
	],
	"./SenderTemplate.vue": [
		"./src/views/Papers/pages/Paper/components/Templates/SenderTemplate.vue",
		0,
		52
	],
	"./ShippingCostTemplate.vue": [
		"./src/views/Papers/pages/Paper/components/Templates/ShippingCostTemplate.vue",
		0,
		53
	],
	"./ShippingNumberTemplate.vue": [
		"./src/views/Papers/pages/Paper/components/Templates/ShippingNumberTemplate.vue",
		0,
		54
	],
	"./ShippingParcelNumberTemplate.vue": [
		"./src/views/Papers/pages/Paper/components/Templates/ShippingParcelNumberTemplate.vue",
		0,
		55
	],
	"./ShippingTemplate.vue": [
		"./src/views/Papers/pages/Paper/components/Templates/ShippingTemplate.vue",
		0,
		56
	],
	"./SocialTemplate.vue": [
		"./src/views/Papers/pages/Paper/components/Templates/SocialTemplate.vue",
		0,
		57
	],
	"./SquareTemplate.vue": [
		"./src/views/Papers/pages/Paper/components/Templates/SquareTemplate.vue",
		0,
		58
	],
	"./StockAddressTemplate.vue": [
		"./src/views/Papers/pages/Paper/components/Templates/StockAddressTemplate.vue",
		0,
		59
	],
	"./StockNameTemplate.vue": [
		"./src/views/Papers/pages/Paper/components/Templates/StockNameTemplate.vue",
		0,
		60
	],
	"./StockPrefixTemplate.vue": [
		"./src/views/Papers/pages/Paper/components/Templates/StockPrefixTemplate.vue",
		0,
		61
	],
	"./TagTemplate.vue": [
		"./src/views/Papers/pages/Paper/components/Templates/TagTemplate.vue",
		0,
		62
	],
	"./TaxIdTemplate.vue": [
		"./src/views/Papers/pages/Paper/components/Templates/TaxIdTemplate.vue",
		0,
		63
	],
	"./TelephoneTemplate.vue": [
		"./src/views/Papers/pages/Paper/components/Templates/TelephoneTemplate.vue",
		0,
		64
	],
	"./TemplateCard.vue": [
		"./src/views/Papers/pages/Paper/components/Templates/TemplateCard.vue",
		0
	],
	"./TextTemplate.vue": [
		"./src/views/Papers/pages/Paper/components/Templates/TextTemplate.vue",
		0,
		65
	],
	"./TotalTemplate.vue": [
		"./src/views/Papers/pages/Paper/components/Templates/TotalTemplate.vue",
		0,
		66
	],
	"./TriangleTemplate.vue": [
		"./src/views/Papers/pages/Paper/components/Templates/TriangleTemplate.vue",
		0,
		67
	],
	"./UnitTemplate.vue": [
		"./src/views/Papers/pages/Paper/components/Templates/UnitTemplate.vue",
		0,
		68
	],
	"./VatTemplate.vue": [
		"./src/views/Papers/pages/Paper/components/Templates/VatTemplate.vue",
		0,
		69
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/views/Papers/pages/Paper/components/Templates lazy recursive ^\\.\\/.*\\.vue$";
module.exports = webpackAsyncContext;